import AbstractController from '../src/services/ControllersRepository/AbstractController';

export default class OrderTags extends AbstractController {
    protected controllerName = 'OrderTags';
}
